import CornerBrackets from "./CornerBrackets";
import { NIN_SLIP_GUIDE } from "../../../utils/adaptiveGuide";

// `guideAspect` (long edge / short edge) is the shape of the slip the camera
// currently sees; DocumentCamera updates it as corners are detected, so the
// guide is the largest box of that shape that fits the screen. Sizing here
// mirrors fitGuide() in utils/adaptiveGuide.js, which the auto-capture check
// validates against — keep the two in sync.
const NinSlipFrame = ({ isOk, guideAspect }) => {
  const c  = isOk ? "rgba(96,165,250,0.7)"  : "rgba(255,255,255,0.35)";
  const cs = isOk ? "rgba(96,165,250,0.9)"  : "rgba(255,255,255,0.6)";
  const aspect = guideAspect || NIN_SLIP_GUIDE.defaultAspect;
  const { maxWidthFraction, maxHeightFraction } = NIN_SLIP_GUIDE;

  return (
    <div
      className="absolute inset-0 flex justify-center items-center pointer-events-none"
      // Size container so the guide below can fit itself to this box via
      // cqw/cqh units.
      style={{ containerType: "size" }}
    >
      <div
        className="relative shrink-0"
        style={{
          "--guide-height": `min(${maxHeightFraction * 100}cqh, ${maxWidthFraction * 100}cqw * ${aspect})`,
          height: "var(--guide-height)",
          aspectRatio: `1 / ${aspect}`,
          boxShadow: "0 0 0 9999px rgba(0,0,0,0.55)",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        {/* The artwork is drawn landscape and turned upright: pre-rotation
            width is the guide's height. */}
        <div
          className="absolute"
          style={{
            left: "50%",
            top: "50%",
            width: "var(--guide-height)",
            height: `calc(var(--guide-height) / ${aspect})`,
            transform: "translate(-50%, -50%) rotate(-90deg)",
          }}
        >
          <svg
            className="absolute inset-0 w-full h-full"
            viewBox="0 0 290 178"
            fill="none"
            preserveAspectRatio="xMidYMid meet"
          >
            {/* Header: logo circle + title bars + right badge */}
            <circle cx="18" cy="17" r="11" stroke={cs} strokeWidth="2" fill="none" />
            <rect x="36" y="9"  width="130" height="8"  rx="3" fill={c} />
            <rect x="36" y="21" width="90"  height="5"  rx="2.5" fill={c} opacity="0.7" />
            <rect x="36" y="30" width="60"  height="4"  rx="2" fill={c} opacity="0.5" />
            <rect x="238" y="9" width="44"  height="28" rx="3" fill={c} opacity="0.5" />

            {/* Divider */}
            <line x1="8" y1="44" x2="282" y2="44" stroke={cs} strokeWidth="0.8" />

            {/* Left column — form fields */}
            <rect x="8"  y="52" width="35" height="4" rx="2" fill={c} opacity="0.5" />
            <rect x="8"  y="59" width="95" height="7" rx="3" fill={c} />

            <rect x="8"  y="72" width="45" height="4" rx="2" fill={c} opacity="0.5" />
            <rect x="8"  y="79" width="115" height="7" rx="3" fill={c} />
            <rect x="8"  y="89" width="100" height="5" rx="2.5" fill={c} opacity="0.6" />

            <rect x="8"  y="100" width="40" height="4" rx="2" fill={c} opacity="0.5" />
            <rect x="8"  y="107" width="80" height="7" rx="3" fill={c} />

            <rect x="8"  y="120" width="55" height="4" rx="2" fill={c} opacity="0.5" />
            <rect x="8"  y="127" width="65" height="7" rx="3" fill={c} />

            {/* Middle column — more fields */}
            <rect x="138" y="52"  width="45" height="4" rx="2" fill={c} opacity="0.5" />
            <rect x="138" y="59"  width="70" height="7" rx="3" fill={c} />

            <rect x="138" y="72"  width="35" height="4" rx="2" fill={c} opacity="0.5" />
            <rect x="138" y="79"  width="55" height="7" rx="3" fill={c} />

            <rect x="138" y="100" width="50" height="4" rx="2" fill={c} opacity="0.5" />
            <rect x="138" y="107" width="75" height="7" rx="3" fill={c} />

            {/* Photo placeholder */}
            <rect x="230" y="50" width="52" height="66" rx="3" stroke={cs} strokeWidth="1.5" fill="none" />
            <circle cx="256" cy="72" r="11" fill={c} opacity="0.45" />
            <path d="M238 113C243 99 271 99 271 113" stroke={cs} strokeWidth="1.5" strokeLinecap="round" fill="none" />

            {/* Bottom NIN strip */}
            <rect x="8" y="148" width="274" height="11" rx="3" fill={c} opacity="0.45" />
            <rect x="8" y="164" width="110" height="5"  rx="2.5" fill={c} opacity="0.35" />
            <rect x="130" y="164" width="80" height="5" rx="2.5" fill={c} opacity="0.35" />
          </svg>

          <div className="absolute inset-0">
            <CornerBrackets isOk={isOk} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NinSlipFrame;
